import React, { useCallback } from 'react';
import { connect } from 'react-redux';

import * as timecardActions from 'features/timesheets/redux/timecardSlice';
import { mergeShifts } from 'features/timesheets/TimesheetsPage/TimecardModal/slices';

import { getIssueOptions } from './helpers';
import Issue from './Issue';

const UnscheduledShift = ({ issue, shift, onMergeShifts, fixDuplicate }) => {
  const handleMergeShifts = useCallback(
    scheduledShiftId => {
      onMergeShifts({
        scheduledShiftId,
        unscheduledShiftId: shift.get('id'),
      }).then(() => {
        const originPath = window.location.pathname;
        fixDuplicate(scheduledShiftId, shift.get('id'), originPath);
      });
    },
    [onMergeShifts, shift, fixDuplicate]
  );

  const options = getIssueOptions(issue, handleMergeShifts);

  return <Issue issue={issue} options={options} />;
};

export default connect(() => ({}), {
  onMergeShifts: mergeShifts,
  fixDuplicate: timecardActions.fixDuplicate,
})(UnscheduledShift);
